module.exports = __webpack_public_path__ + "Bg_reports_christmas.f1807173a4d728b4a934cb9257a889bd.png";